import { Link } from "react-router-dom";

export default function Card(props) {
    return (
        <Link className="card m-4 w-25 w-lg-25 mx-xxl-0"   to={'/referenser' } >
            <img src={props.img} className="card-img-top" alt="..."   />
            {/* <div className="card-body">
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <Button text="Referenser" link="referenser" />
            </div> */}
        </Link>
    )
}